@if (isShow) {
  <div class="gallery" (click)="onClose()" [class.loading]="isLoading" [class.is-show]="isShow">
    <div class="gallery-inner" #gallery_inner>
      <div class="gallery-content" #gallery_content>
        @if (currentItem.isImage()) {
          <img
            class="gallery-img"
            data-cy="gallery-image"
            (click)="preventCloseOnContent($event)"
            (load)="onContentLoad()"
            [src]="currentItem.previewLink()"
          />
        }
        @if (currentItem.isVideo()) {
          <video
            class="gallery-video"
            data-cy="gallery-video"
            controls
            autoplay
            (click)="preventCloseOnContent($event)"
            (loadeddata)="onContentLoad()"
            [src]="currentItem.previewLink()"
          ></video>
        }
        @if (currentItem.isAudio()) {
          <audio
            class="gallery-audio"
            data-cy="gallery-audio"
            controls
            autoplay
            (click)="preventCloseOnContent($event)"
            (loadeddata)="onContentLoad()"
            [src]="currentItem.previewLink()"
          ></audio>
        }
        <p class="gallery-caption" data-cy="gallery-caption" #gallery_caption>
          {{ currentItem.file_name }}
        </p>
      </div>
      @if (isLoading) {
        <div class="gallery-loader"></div>
      }
      @if (canNavigate()) {
        <button class="previous-button gallery-button" (click)="onPrevious($event)"></button>
      }
      @if (canNavigate()) {
        <button class="next-button gallery-button" (click)="onNext($event)"></button>
      }
    </div>
  </div>
}
